// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signupInitWrapper[data-v-10ce060b]{padding-bottom:24px}.loginPrompt[data-v-10ce060b]{text-align:center;cursor:pointer}.line[data-v-10ce060b]{background-color:var(--color-light-grey);height:1px;margin:24px 0 16px}.plain[data-v-10ce060b]{color:var(--color-dark-grey)}.colored[data-v-10ce060b]{color:var(--color-main)}.selector[data-v-10ce060b]{margin-top:24px}", ""]);
// Exports
module.exports = exports;
